



































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  watch
} from "@vue/composition-api";
import ClickOutside from "vue-click-outside";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
export type SelectItem = {
  value: string | number;
  label: string;
  description?: string;
};

export default defineComponent({
  name: "OccSearchSelectbox",
  components: {
    OccHeading
  },
  directives: {
    ClickOutside
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    selectedValue: {
      type: [String, Number],
      default: undefined
    },
    selectList: {
      type: Array as PropType<SelectItem[]>,
      required: true
    },
    minWidth: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change"],
  setup(props, { emit }) {
    const searchText = ref("");
    const searchTextInputRef = ref<HTMLInputElement>();
    const showSelectList = ref(false);
    const selected = ref(false);

    const filterdSelectList = computed(() =>
      selected.value
        ? props.selectList.filter(item => item.value !== props.selectedValue)
        : props.selectList.filter(item => item.label.includes(searchText.value))
    );

    const selectedItem = computed(() =>
      props.selectList.find(
        selectItem => selectItem.value === props.selectedValue
      )
    );

    const clickSelectbox = () => {
      if (props.disabled) {
        return;
      }
      showSelectList.value = true;
    };
    const onClickOutside = () => {
      showSelectList.value = false;
      searchTextInputRef.value?.blur();
    };
    const onClickSelectItem = (item: SelectItem) => {
      searchText.value = item.label;
      showSelectList.value = false;
      selected.value = true;

      emit("change", item.value);
    };
    const onInputSearchText = (event: Event) => {
      if (event.target instanceof HTMLInputElement) {
        searchText.value = event.target.value;
      }
      selected.value = false;
    };
    const onBlurSearchTextInput = () => {
      if (showSelectList.value) {
        searchTextInputRef.value?.focus();
      }
    };

    watch(showSelectList, nextShowSelectList => {
      if (nextShowSelectList) {
        searchTextInputRef.value?.focus();
      } else {
        searchTextInputRef.value?.blur();
      }
    });

    watch(
      selectedItem,
      nextSelectedItem => {
        if (nextSelectedItem?.value) {
          searchText.value = nextSelectedItem.label;
        }
      },
      {
        immediate: true
      }
    );

    return {
      searchTextInputRef,
      searchText,
      filterdSelectList,
      showSelectList,
      selectedItem,
      clickSelectbox,
      onClickOutside,
      onClickSelectItem,
      onInputSearchText,
      onBlurSearchTextInput
    };
  }
});
